import { Component, OnInit } from '@angular/core';
import { PartnerInput } from '../../../models/partner-input.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { OsmosisService } from '../../services/osmosis.service';
import { SharedEngagementTableComponent } from '../../shared/engagement-table/engagement-table.component';

@Component({
  selector: 'app-customer-survey-review-list',
  templateUrl: './customer-survey-review-list.component.html',
  styleUrls: ['./customer-survey-review-list.component.scss'],
  standalone: true,
  imports: [SharedEngagementTableComponent]
})
export class CustomerSurveyReviewListComponent implements OnInit {
  engagementList!: PartnerInput[];
  isPoeInvoice = true;
  prevDocumentType!: string;
  loading!: boolean;

  constructor(private osm: OsmosisService) {}

  ngOnInit() {
    this.initializeInvoiceDocReviewList();
    this.prevDocumentType = PreviewDocumentTypes.customerSurvey;
  }

  initializeInvoiceDocReviewList() {
    this.loading = true;
    this.osm
      .getEngagementsForCustomerSurveyReview()
      .subscribe(serviceOutput => {
        this.engagementList = serviceOutput;
        this.loading = false;
      });
  }
}
